import { registerLocaleData } from '@angular/common';
import localeNLExtra from '@angular/common/locales/extra/nl';
import localeNL from '@angular/common/locales/nl';
import { enableProdMode } from '@angular/core';
import { bootstrapApplication, enableDebugTools } from '@angular/platform-browser';
import { enableNeqtoDebugTools } from '@core/helpers/neqto-debug.helper';
import { environment } from '@environments/environment';
import '@maplibre/maplibre-gl-leaflet';
import * as Sentry from '@sentry/angular';
import 'hammerjs';
import 'maplibre-gl';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

registerLocaleData(localeNL, 'nl-NL', localeNLExtra);

if (environment.production) {
  enableProdMode();
}

if (environment.sentryUrl) {
  const options = {
    dsn: environment.sentryUrl,
    normalizeDepth: 0,
    environment: environment.name,
    ignoreErrors: [
      'Non-Error exception captured',
      'NG0100: ExpressionChangedAfterItHasBeenCheckedError',
      "Cannot read properties of null (reading 'postMessage')",
      'illegal access',
      /EmptyError: no elements in sequence/,
      'no elements in sequence',
      /Object captured as exception with keys:/,
    ],
    integrations: [
      Sentry.feedbackIntegration({
        showBranding: false,
        autoInject: false,
        isNameRequired: true,
        isEmailRequired: true,
      }),
    ]
  };

  if (environment.name === 'Test' || environment.name === 'Acceptance') {
    Sentry.init({
      ...options,
      tracesSampleRate: 1.0, //  Capture 100% of the transactions
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
      integrations: [
        ...options.integrations,
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
          maskAllText: false,
          blockAllMedia: false,
        })
      ],
    });
  } else {
    Sentry.init({ ...options });
  }
}

const bootstrap = () => bootstrapApplication(AppComponent, appConfig);

bootstrap()
  .then((appRef) => {
    const appComponent = appRef.components[0];

    if (!environment.production) {
      enableDebugTools(appComponent);
    }

    enableNeqtoDebugTools(appComponent);
  })
  .catch((err) => console.error(err));
